import { graphql, useStaticQuery } from 'gatsby';
import StateOfHousingAllowance from '@/components/organisms/state-of-housing-allowance/stateOfHousingAllowance';
import GeneralPageTemplate from '@/components/template/generalPageTemplate';
import '../../styles/index.scss';

const ConsultaPostulacionSubsidioDeVivienda = () => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_PERSONAS_POST_SUB_VIVIENDA {
            allContentfulTemplate(
                filter: {
                    titulo: {
                        eq: "Interna de certificados y consultas personas publico y privado > Consulta tu postulación de subsidio de vivienda"
                    }
                }
            ) {
                nodes {
                    metaInfo {
                        metaTitulo
                        metaDescripcion
                        metaImagen {
                            gatsbyImage(
                                width: 700
                                formats: [AUTO, WEBP]
                                placeholder: BLURRED
                            )
                            file {
                                url
                            }
                        }
                        urlCanonical
                        noIndex
                    }
                    migaDePan
                    nombre
                    subtitulo
                    lista
                    secciones {
                        nombre
                        descripcion {
                            raw
                        }
                        imagen {
                            gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                            title
                            file {
                                url
                            }
                            svg {
                                publicURL
                            }
                        }
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            nombre
                            subtitulo
                            imagen {
                                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                                title
                                file {
                                    url
                                }
                                svg {
                                    publicURL
                                }
                            }
                            lista
                            referencias {
                                ... on ContentfulTemplate {
                                    nombre
                                    subtitulo
                                    copyBoton
                                    redireccion
                                    listaJson {
                                        name
                                        value
                                    }
                                    imagen {
                                        gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                                        title
                                        file {
                                            url
                                        }
                                        svg {
                                            publicURL
                                        }
                                    }
                                }
                            }
                            boton {
                                copy
                                redireccion
                            }
                        }
                    }
                    estaActivo
                    referenceBlock {
                        ... on ContentfulSimpleBlock {
                            contentfulid
                            title
                            subtitle
                            media {
                                gatsbyImage(
                                    width: 700
                                    formats: [AUTO, WEBP]
                                    placeholder: BLURRED
                                )
                                title
                                file {
                                    url
                                }
                                svg {
                                    publicURL
                                }
                            }
                            config {
                                internal {
                                    content
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const metaData = data?.allContentfulTemplate?.nodes[0]?.metaInfo[0];
    const content = data?.allContentfulTemplate?.nodes[0];

    return (
        <GeneralPageTemplate
            data={metaData}
            hasLoader={true}
            hideSide={true}
            isPrivate={false}
            isActive={content?.estaActivo}
        >
            <StateOfHousingAllowance contentInfo={content} />
        </GeneralPageTemplate>
    );
};

export default ConsultaPostulacionSubsidioDeVivienda;
